import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { convertStringToElements } from "@vds/html-parsers";

import { setA11yContent } from "../../NavigationHelper/actions";
import { checkNestedObject } from "utils/checkNestedObject";
import { checkPendingCases, createCase } from "../actions/commonFormerCustomerAPI";
import { submitAppeal } from "./actions/submitAppeal";
import { setBreadcrumbList } from "common-components/BreadCrumbs/actions";
import Header from "common-components/Header";
import Container from "common-components/Container";
import RectangleLoader from "common-components/RectangleLoader";
import Alert from "common-components/Alert";
import { AppealForm } from "./AppealForm";
import { FormerPendingRequest } from "../FormerPendingRequest";

class FormerAndGuestSubmitAppeal extends Component {

  state = {
    pendingModal: false,
  };
  componentDidMount() {
    if (checkNestedObject(this.props, "location", "state", "appealContent")) {
      this.props.setA11yContent("Submit Appeal", this.props.location.state.appealContent.sc_pagetitle);
    }

    if (checkNestedObject(this.props, "pageContent", "breadCrumbs", "landingPage")) {
      const { landingPage, requestHistory, submitAppeal } = this.props.pageContent.breadCrumbs;
      this.props.setBreadcrumbList([
        { label: landingPage, path: this.props.BreadCrumbsLink && this.props.BreadCrumbsLink[0] ? this.props.BreadCrumbsLink[0].requestStatusPageName : null },
        { label: requestHistory, path: this.props.BreadCrumbsLink && this.props.BreadCrumbsLink[1] ? this.props.BreadCrumbsLink[1].requestHistoryPageName : null },
        { label: submitAppeal, path: "" }
      ]);
    }

  }


  onCancel = e => {
    this.props.history.push("/privacy/your-data/request-history", {
      isToken: this.props.location.state.isToken
    });
  };


  onSubmit = (e, values) => {
    e.preventDefault();

    const route = "/privacy/your-data/appeal-confirmation";
    const next = () =>
      this.props.history.push(route, {
        nextRoute: this.props.location.state.requestHistoryPath,
        appealConfirmationContent: this.props.location.state.appealConfirmationContent,
        isToken: this.props.location.state.isToken
      });

    const { payload } = this.props.location.state;
    this.props.checkPendingCases(payload.email, payload.intent, null, payload.serviceType, null, payload.txnId).then(() => {
      if (!this.props.error) {
        if (this.props.isCasePending) {
          this.setState({ pendingModal: true })
        } else {
          this.props.createCase(payload.email, payload.txnId, payload.FirstName, payload.lastName,
            payload.intent, null, payload.serviceType, null, payload.accountId, null, payload.role, payload.state, payload.appealType).then(() => {
              if (!this.props.error) {
                next();
              }
            })
        }
      }
    })
  };

  render() {


    if (this.props.loading) {
      return <RectangleLoader id={"FormerLoader"}/>;
    }

    if (!this.props.pageContent) {
      return <Redirect to={this.props.BreadCrumbsLink && this.props.BreadCrumbsLink[0] ? this.props.BreadCrumbsLink[0].requestStatusPageName : ""} />;
    }

    if (!checkNestedObject(this.props, "location", "state", "appealContent")) {
      return <Redirect to={this.props.BreadCrumbsLink && this.props.BreadCrumbsLink[0] ? this.props.BreadCrumbsLink[0].requestStatusPageName : ""} />;
    }


    const appeal_details = this.props.location.state.appealContent;
    const { section_title, section_description } = appeal_details;
    const requestPending = this.props.location.state.pendingModelContent;
    return (
      <Container>
        {this.props.error ? <Alert alertType="error">{this.props.error}</Alert> : null}

        <Header>{section_title}</Header>
        <p style={{ marginTop: "26px", marginBottom: "45px", maxWidth: "665px" }}>{convertStringToElements(section_description)}</p>
        <AppealForm content={appeal_details} onSubmit={this.onSubmit} onCancel={this.onCancel} />
        {this.state.pendingModal ?
          <FormerPendingRequest
             modalContent={requestPending}
            dateOfRequest={"date"}
            closeModal={() => {
              this.setState({
                pendingModal: !this.state.pendingModal
              }, () => {
                if(this.props.BreadCrumbsLink && this.props.BreadCrumbsLink[1] && this.props.BreadCrumbsLink[1].requestHistoryPageName){
                this.props.history.push(this.props.BreadCrumbsLink[1].requestHistoryPageName)
                }
              })
            }}
          /> : ""
        }
      </Container>
    );
  }
}

const mapStateToProps = ({
  pageContent,
  loadingAndErrorState: { loading, error },
  BreadCrumbsLink,
  pendingCase: { isCasePending },
}) => ({
  pageContent,
  loading,
  error,
  BreadCrumbsLink,
  isCasePending
});


export default connect(
  mapStateToProps,
  { setA11yContent, submitAppeal, setBreadcrumbList, createCase, checkPendingCases }
)(FormerAndGuestSubmitAppeal);
